export default __webpack_public_path__ + "static/best-practices-selecting-elements-aaef7b4485b8d6c5ced01b062eb1dd51.webp";